
import { Base } from '../../components/base-component';

import { AnalyticsService } from '../../services/analytics.service';

import './form-item-stansure.component.scss';

export class FormItemStansure extends Base {

	form: HTMLFormElement;
	submitBtn: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = this.element.querySelector('.js-stansure__button');

	}

	bindEvents() {
		
		this.submitBtn.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.actionForm(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		});
	}

	actionForm(form: HTMLFormElement, loader: Element, thankyou: Element) {

		// paremeters
		let _firstName: any = this.form.querySelector('input[name=first-name]');
		let _surname: any = this.form.querySelector('input[name=last-name]');
		let _contact: any = this.form.querySelector('input[name=contact-number]');
		let _email: any = this.form.querySelector('input[name=email-address]');
	
		// additional containers
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');

		let postData = '';

		if (_firstName) {
			postData += 'firstname=' + _firstName.value;
		}
		if (_surname) {
			postData += '&surname=' + _surname.value;
		}
		if (_contact) {
			postData += '&contact=' + _contact.value;
		}
		if (_email) {
			postData += '&email=' + _email.value;
		}

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/stansureleadsservice.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			loader.classList.remove('active');
			if (!response.data || (response.data.match(/(invalid)/gi))) {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
				error.classList.add('active');
				thankyou.classList.add('active');
				success.classList.remove('active');
			} else {
				analyticsService.dtmFormComplete('complete', response.code);
				thankyou.classList.add('active');
				success.classList.add('active');
				error.classList.remove('active');
			}
		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-stansure/form-item-stansure.component.ts